import ItemTypes from '../sections/tab_dnd/dnd_types';
import {DropTarget} from 'react-dnd';
//import {findDOMNode} from 'react-dom';

const cardTarget = {
    canDrop(props, monitor) {
        //const item = monitor.getItem();
        return true;
    },

    hover(props, monitor, component) {
        /* const clientOffset = monitor.getClientOffset();
        const componentRect = findDOMNode(component).getBoundingClientRect();
        const isJustOverThisOne = monitor.isOver({shallow: true });
        const canDrop = monitor.canDrop(); */
        return true;
    },

    drop(props, monitor, component) {
        if (monitor.didDrop()) {
            return;
        }

        //const item = monitor.getItem();

        return {
            moved: true,
            index: props.index,
            group: props.group,
        };
    },
};

const collect = (connect, monitor) => ({
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
    isOverCurrent: monitor.isOver({ shallow: true }),
    canDrop: monitor.canDrop(),
    itemType: monitor.getItemType(),
});

export const placeholderDropTarget = DropTarget(
    ItemTypes.AVAILABLE_SECTION,
    cardTarget,
    collect
);



// WEBPACK FOOTER //
// ./src/containers/builder/dsdt/placeholder_drop_target.js